export const initialStateData =  {
    id: null,
    gender: 'Boy',
    category: null,
    customCategory: null,
    subcategory: null,
    customSubcategory: null,
    priority: 'Normal',
    agency: null,
    language: 'English',
    customLanguage: null,
    source: null,
    space: 'Box',
    size: null,
    hlinebg: 'Dark',
    hline1: null,
    hline2: null,
    hline3: null,
    hline1fs: null,
    hline2fs: null,
    hline3fs: null,
    contentbg: 'Normal',
    contentfs: '8px',
    content: null,
    contactbg: 'Normal',
    whatsapp: null,
    mobile: null,
    email: null,
    files: [],
    InsertDate: null
  }


  export const initialfORMData =  {
    id: null,
    gender: 'Boy',
    category: null,
    customCategory: null,
    subcategory: null,
    customSubcategory: null,
    priority: 'Normal',
    agency: null,
    language: 'English',
    customLanguage: null,
    source: null,
    space: 'Box',
    size: null,
    hlinebg: 'Dark',
    hline1: { text: null, fontSize: '12px' },
    hline2: { text: null, fontSize: null },
    hline3: { text: null, fontSize: null },
    contentbg: 'Normal',
    contentfs: '12px',
    content: null,
    contactbg: 'Normal',
    whatsapp: null,
    mobile: null,
    email: null,
    files: [],
    InsertDate: null
  }